export const iconButtonRecipe = {
  sizes: {
    touch: ({ theme }) => ({
      minWidth: theme.spacing(5.5),
      minHeight: theme.spacing(5.5),
      color: theme.palette.primary.interactive,
    }),
  },
};
